export default __webpack_public_path__ + "static/media/myportfolio_navicon.32ef37fc.svg";